<template>
    <!-- 班级列表页 -->
    <div class="classList">
        <!-- <div class="searchBox">
            <el-input size="medium"  prefix-icon="el-icon-search" placeholder="请输入班级名称" v-model="input" clearable></el-input>
            <el-button type="primary"  icon="el-icon-search" plain>搜索</el-button>
            <el-button plain>重置</el-button>
        </div> -->
        <div  class="search-content conditionSearchBox">
            <div class="conditionItem">
                <el-input size="medium"  prefix-icon="el-icon-search" placeholder="请输入班级名称" v-model="params.condition.name" clearable></el-input>
            </div>
            <div class="conditionItem">
                <el-button type="hollowOut" @click="triggerSearch">
                    <i class="el-icon-search mr-5"></i>搜索</el-button>
                <el-button @click="resetSearchCondition">
                    <i class="el-icon-refresh mr-5"></i>重置</el-button>
            </div>
        </div>
        <div class="listBox mt-20">
            <el-button @click="addClass" type="primary" class="icon el-icon-plus">新增班级</el-button>
             <!-- 表格 -->
        </div>
        <div v-loading="loading" class="table-content mt-15">
            <el-table class="table-fixed-col" ref="multipleTable" border :data="tableData" style="width: 100%">
                <el-table-column key="index" type="index" :width="getTableHeaderWidthByOrderCol()"  align="center" label="序号"
                    fixed="left">
                    <template slot-scope="scope">
                        <TableSort :index="scope.$index" :page="params.page" :pagesize="params.pagesize" />
                    </template>
                </el-table-column>
                <el-table-column   min-width="240" show-overflow-tooltip key="name" align="left" prop="name" label="班级名称">
                    <template slot-scope="scope">
                        <div class="classNameBox">
                            <img :src="scope.row.coveratturl.split(',')[0]" alt="">
                            <span class="jumpname text-ellipse" @click="goDetail(scope.row)">{{scope.row.name}}</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column width="100" key="totalstudentcount" align="center" prop="totalstudentcount" label="学员数">
                </el-table-column>
                <el-table-column width="140" key="finishperiodcount" align="center" prop="finishperiodcount" label="已上课/排课数">
                    <template slot-scope="scope">
                        <span>{{scope.row.finishperiodcount+'/'+scope.row.totalperiodcount}}</span>
                    </template>
                </el-table-column>
                <el-table-column width="100" key="totalcoursecount" align="center" prop="totalcoursecount" label="课程总数">
                </el-table-column>
                <el-table-column width="100" key="totalscore" align="center" prop="totalscore" label="总学分数">
                </el-table-column>
                <el-table-column width="200" key="datetime" align="center" prop="datetime" label="创建时间">
                </el-table-column>
                <el-table-column width="100" key="statusname" align="center" prop="statusname" label="结业状态">
                </el-table-column>
                <el-table-column :width="getTableHeaderWidthByOpButton3()" fixed="right" key="set" align="right" label="操作">
                    <template slot-scope="scope">
                        <div class="color-brand flex jc-sb ai-c">
                            <span class="color-brand pointer" @click="goDetail(scope.row)">学员</span>
                            <span @click="goDetail(scope.row, 'pk')"  class="color-brand pointer">排课</span>
                            <el-dropdown v-if="scope.row.status == 10 || scope.row.status === 0"  @command="command($event, scope.row)" trigger="click" class="non-shrink">
                                <span style="font-size: 12px" class="
                                    el-dropdown-link
                                    color-brand
                                    pointer
                                ">更多</span>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item :command="item.value" v-for="(item,index) in moreOptionArr" :key="index">
                                        <span >{{item.name}}</span>
                                    </el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                            <span v-else class="color-text-sec">更多</span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                :hide-on-single-page="!total || total < 1"
                class="mt-20 flex ai-c jc-fd"
                @size-change="handePageSizeChange"
                @current-change="curPageChange"
                @prev-click="curPageChange"
                @next-click="curPageChange"
                layout="total, sizes, prev, pager, next"
                :total="total"
                :page-sizes="[10, 20, 30, 40, 50, 100]"
                :page-size="20"
                :current-page.sync="params.page"
                background
            ></el-pagination>
        </div>
        <!-- 分享dialog -->
        <Share ref="share" />
        <!-- 新增班级 -->
        <AddClass ref="addClass" />
    </div>
</template>
<script>
import TableSort from '@/components/measComponents/tableSort/tableSort.vue'
import {getClassList,updateClassStatus} from '@/api/measApi/teachManagement.js'
import {getTableDefaultPageSize} from '@/assets/measAssets/js/tools.js'
import Share from './components/share.vue'
import AddClass from './components/addClass.vue'
import {mapGetters} from 'vuex'
export default {
    data(){
        return {
            loading: false,
            tableData: [],
            moreOptionArr: [
                { name: '分享', value: 0 },
                { name: '编辑', value: 1 },
                { name: '删除', value: 2 },
                { name: '结业', value: 3 }
            ],
            params: {
                condition: {
                    campuscode: '',
                    campusname: '',
                    name: '',
                    status: ''
                },
                orderbyname: '',
                orderbyorder: '',
                page: 1,
                pagesize: getTableDefaultPageSize()
            },
            updateStatusParams: {
                codes: '',
                status: ''
            },
            total: 0
        }
    },
    components: {
        TableSort,
        Share,
        AddClass
    },
    computed: {
        ...mapGetters(['user'])
    },
    created(){
        this.init()
    },
    methods: {
        init(){
            this.params.page = 1
            this.getClassList()
        },
        // 获取班级列表
        getClassList(){
            this.loading = true
            this.params.condition.campuscode = this.user.campuscode
            this.params.condition.campusname = this.user.campusname
            getClassList(this.params).then(res => {
                this.loading = false
                if(res.code === '000'){
                    this.tableData = res.data
                    this.total = res.pageinfo.rowcount
                }
            }).catch(err => {
                this.loading = false
            })
        },
        // 分页大小改变
        handePageSizeChange(e) {
            this.params.page = 1
            this.params.pagesize = e
            this.getClassList()
        },
        curPageChange(e) {
            this.params.page = 1
            this.params.page = e
            this.getClassList()
        },
        triggerSearch(){
            this.params.page = 1
            this.getClassList()
        },
        resetSearchCondition(){
            this.params.condition.name = ''
            this.params.page = 1
             this.getClassList()
        },
        updateClassStatus(){
            updateClassStatus(this.updateStatusParams).then(res => {
                if(res.code === '000'){
                    this.$message.success(res.msg)
                    this.getClassList()
                }else{
                    this.$message.error(res.msg)
                }
                console.log(res,'修改班级状态为删除')
            })
        },
        // 新增班级
        addClass(){
            this.$refs.addClass.init('new')
        },
        command(val, row){
            console.log(val,row)
            switch (val) {
                case 0:
                    this.$refs.share.init(row)
                    break;
                case 1:
                    this.$refs.addClass.init('edit', row.code)
                    break;
                case 2:
                    this.$confirm('班级删除后将不在前台展示，会影响正在学习的学员，继续吗?', '删除', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        customClass: 'measElMessage'
                    }).then(() => {
                        this.updateStatusParams.codes = row.code
                        this.updateStatusParams.status = 100 
                        this.updateClassStatus()
                    })
                    break;
                case 3:
                    this.updateStatusParams.codes = row.code
                    this.updateStatusParams.status = 30 
                    this.updateClassStatus()
                    break;
            }
        },
        goDetail(value, type){
            this.$router.push({name: 'ClassDetail', query: {code: value.code, type: type}})
        },
        jump(){
            
        }
    }
}
</script>
<style lang="scss" scoped>
.classNameBox{
    display: flex;
    width: 100%;
    align-items: center;
    img{
        height: 40px;
        width: 80px;
        margin-right: 6px;
    }
    .jumpname{
        color: #0B75FA;
        cursor: pointer;
    }
}
.classList {
    .searchBox {
        display: flex;
        ::v-deep .el-input{
            width: 400px;
            margin-right: 10px;
        }
    }
    .listBox{
        font-size: 14px;
        .icon-add{
            margin-right: 6px;
        }
    }
}
</style>